import * as type from "../types/single-client";

const initialState = {
  details: {},
  roles: [],
  sales: [],
  notes: [],
  activeSelectionYear: null,
  activeSalesKey: null,
  fetchDetails: {
    status: null,
    loading: true,
    error: null,
  },
  fetchRoles: {
    status: null,
    loading: true,
    error: null,
  },
  fetchSales: {
    status: null,
    loading: true,
    error: null,
  },
  fetchNotes: {
    status: null,
    loading: true,
    error: null,
  },
  addSale: {
    status: null,
    loading: false,
    error: null,
  },
  updateDetails: {
    status: null,
    loading: false,
    error: null,
  },
  deleteClient: {
    status: null,
    loading: false,
    error: null,
  },
  deleteSale: {
    status: null,
    loading: false,
    error: null,
  },
  updateSale: {
    status: null,
    loading: false,
    error: null,
  },
  addNote: {
    status: null,
    loading: false,
    error: null,
  },
  removeNote: {
    status: null,
    loading: false,
    error: null,
  },
  selectionYears: {
    status: null,
    loading: true,
    error: null,
  },
  showModals: {
    removeModal: false,
    removeSaleModal: false,
    editSaleModal: false,
    editModal: false,
    saleModal: false,
  },
  activeSale: {
    saleVat: null,
    saleStatus: null,
    salePrice: null,
    saleName: null,
    saleDescription: null,
    saleDate: null,
    key: null,
    id: null,
  },
};

export const singleClient = (state = initialState, payload) => {
  switch (payload.type) {
    case type.REQUEST_SINGLE_CLIENT_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_DETAILS:
      return {
        ...state,
        details: payload.details,
        fetchDetails: {
          ...state.fetchDetails,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CLIENT_DETAILS:
      return {
        ...state,
        details: {},
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.RESET_SINGLE_CLIENT_DETAILS:
      return {
        ...state,
        details: null,
        fetchDetails: {
          ...state.fetchDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.CHANGE_SINGLE_CLIENT_MODAL:
      if (
        payload.modal.removeModal === true ||
        payload.modal.removeModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            removeModal: payload.modal.removeModal,
          },
        };
      } else if (
        payload.modal.editModal === true ||
        payload.modal.editModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editModal: payload.modal.editModal,
          },
        };
      } else if (
        payload.modal.saleModal === true ||
        payload.modal.saleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            saleModal: payload.modal.saleModal,
          },
        };
      } else if (
        payload.modal.removeSaleModal === true ||
        payload.modal.removeSaleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            removeSaleModal: payload.modal.removeSaleModal,
          },
        };
      } else if (
        payload.modal.editSaleModal === true ||
        payload.modal.editSaleModal === false
      ) {
        return {
          ...state,
          showModals: {
            ...state.showModals,
            editSaleModal: payload.modal.editSaleModal,
          },
        };
      } else {
        return state;
      }
    case type.REQUEST_SINGLE_CLIENT_ROLES:
      return {
        ...state,
        roles: {},
        fetchRoles: {
          ...state.fetchRoles,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_ROLES:
      return {
        ...state,
        roles: payload.roles,
        fetchRoles: {
          ...state.fetchRoles,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CLIENT_ROLES:
      return {
        ...state,
        roles: {},
        fetchRoles: {
          ...state.fetchRoles,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SINGLE_CLIENT_ROLES:
      return {
        ...state,
        roles: {},
        fetchRoles: {
          ...state.fetchRoles,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_SINGLE_CLIENT_NOTES:
      return {
        ...state,
        notes: [],
        fetchNotes: {
          ...state.fetchNotes,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_NOTES:
      return {
        ...state,
        notes: payload.notes,
        fetchNotes: {
          ...state.fetchNotes,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CLIENT_NOTES:
      return {
        ...state,
        notes: [],
        fetchNotes: {
          ...state.fetchNotes,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SINGLE_CLIENT_NOTES:
      return {
        ...state,
        notes: [],
        fetchNotes: {
          ...state.fetchNotes,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_SINGLE_CLIENT_SALES:
      return {
        ...state,
        sales: {},
        fetchSales: {
          ...state.fetchSales,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_SALES:
      return {
        ...state,
        sales: payload.sales,
        fetchSales: {
          ...state.fetchSales,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.REVOKE_SINGLE_CLIENT_SALES:
      return {
        ...state,
        sales: {},
        fetchSales: {
          ...state.fetchSales,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SINGLE_CLIENT_SALES:
      return {
        ...state,
        sales: {},
        fetchSales: {
          ...state.fetchSales,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REQUEST_ADD_SINGLE_CLIENT_SALE:
      return {
        ...state,
        addSale: {
          ...state.addSale,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_CLIENT_SALE:
      return {
        ...state,
        addSale: {
          ...state.addSale,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_SINGLE_CLIENT_SALE:
      return {
        ...state,
        addSale: {
          ...state.addSale,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_SINGLE_CLIENT_SALE:
      return {
        ...state,
        addSale: {
          ...state.addSale,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_UPDATE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        updateDetails: {
          ...state.updateDetails,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_REMOVE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_REMOVE_SINGLE_CLIENT_DATA:
      return {
        ...state,
        deleteClient: {
          ...state.deleteClient,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_ACTIVE_SALES_KEY:
      return {
        ...state,
        activeSalesKey: payload.key,
      };
    case type.RESET_SINGLE_CLIENT_ACTIVE_SALES_KEY:
      return {
        ...state,
        activeSalesKey: null,
      };
    case type.REQUEST_REMOVE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        deleteSale: {
          ...state.deleteSale,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        deleteSale: {
          ...state.deleteSale,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_REMOVE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        deleteSale: {
          ...state.deleteSale,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_REMOVE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        deleteSale: {
          ...state.deleteSale,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.SET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY:
      return {
        ...state,
        activeSale: payload.details,
      };
    case type.RESET_SINGLE_CLIENT_ACTIVE_SALE_DISPLAY:
      return {
        ...state,
        activeSale: {
          ...state.activeSale,
          saleVat: null,
          saleStatus: null,
          salePrice: null,
          saleName: null,
          saleDescription: null,
          saleDate: null,
          key: null,
          id: null,
        },
      };
    case type.REQUEST_UPDATE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        updateSale: {
          ...state.updateSale,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_UPDATE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        updateSale: {
          ...state.updateSale,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_UPDATE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        updateSale: {
          ...state.updateSale,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_UPDATE_SINGLE_CLIENT_SALE:
      return {
        ...state,
        updateSale: {
          ...state.updateSale,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_ADD_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_ADD_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_ADD_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_ADD_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        addNote: {
          ...state.addNote,
          status: null,
          loading: false,
          error: null,
        },
      };
    case type.REQUEST_REMOVE_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        removeNote: {
          ...state.removeNote,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_REMOVE_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        removeNote: {
          ...state.removeNote,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.GRANT_REMOVE_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        removeNote: {
          ...state.removeNote,
          status: "success",
          loading: false,
          error: null,
        },
      };
    case type.RESET_REMOVE_SINGLE_CLIENT_NOTE:
      return {
        ...state,
        removeNote: {
          ...state.removeNote,
          status: null,
          loading: false,
          error: null,
        },
      };
    /* */
    case type.REQUEST_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: true,
          error: null,
        },
      };
    case type.REVOKE_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: false,
          error: payload.message,
        },
      };
    case type.SET_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: payload.content,
          loading: false,
          error: null,
        },
      };
    case type.RESET_SELECTION_YEARS:
      return {
        ...state,
        selectionYears: {
          ...state.selectionYears,
          status: null,
          loading: false,
          error: null,
        },
      };
    /* */
    case type.SET_ACTIVE_SELECTION_YEAR:
      return {
        ...state,
        activeSelectionYear: payload.year,
      };
    case type.RESET_ACTIVE_SELECTION_YEAR:
      return {
        ...state,
        activeSelectionYear: null,
      };
    /* */
    default:
      return state;
  }
};
